"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Tooltip", {
    enumerable: true,
    get: function() {
        return Tooltip;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _reactdominteractions = require("@floating-ui/react-dom-interactions");
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Text = require("../Text/Text");
const _Theme = require("../../contexts/Theme");
const _hooks = require("../../hooks");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const getArrowOffset = (variant, showArrow)=>showArrow || variant === "advanced" ? variant === "basic" ? 6 : 10 : 4;
const Tooltip = (param)=>{
    let { title, placement = "bottom", showArrow = false, variant = "basic", imageUrl, description, primaryAction, secondaryAction, children, manualInteractionsControl = false, focusable = true, limitMobileWidth = false } = param;
    const { zIndexes } = (0, _Theme.useTheme)();
    const [isActive, setActive] = _react.default.useState(false);
    const arrowRef = (0, _react.useRef)(null);
    const { x, y, reference, floating, strategy, placement: actualPlacement, context, middlewareData: { arrow: { x: arrowX, y: arrowY } = {} }, update } = (0, _reactdominteractions.useFloating)({
        open: isActive,
        onOpenChange: setActive,
        placement,
        middleware: [
            (0, _reactdominteractions.offset)(getArrowOffset(variant, showArrow)),
            (0, _reactdominteractions.flip)(),
            (0, _reactdominteractions.shift)(),
            (0, _reactdominteractions.arrow)({
                element: arrowRef
            })
        ]
    });
    const isMobile = (0, _hooks.useIsMobileWidth)();
    const limitWidth = isMobile && limitMobileWidth;
    const arrowSide = (0, _react.useMemo)(()=>{
        var _actualPlacement_split_;
        return (_actualPlacement_split_ = ({
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        })[actualPlacement.split("-")[0]]) !== null && _actualPlacement_split_ !== void 0 ? _actualPlacement_split_ : "top";
    }, [
        actualPlacement
    ]);
    const arrowRotateDegree = (0, _react.useMemo)(()=>{
        return ({
            top: 0,
            right: 90,
            bottom: 180,
            left: 270
        })[actualPlacement.split("-")[0]];
    }, [
        actualPlacement
    ]);
    const hover = (0, _reactdominteractions.useHover)(context, {
        handleClose: (0, _reactdominteractions.safePolygon)({
            blockPointerEvents: false
        })
    });
    const focus = (0, _reactdominteractions.useFocus)(context, {
        enabled: focusable
    });
    const role = (0, _reactdominteractions.useRole)(context, {
        role: "tooltip"
    });
    const dismiss = (0, _reactdominteractions.useDismiss)(context, {
        ancestorScroll: true
    });
    const { getReferenceProps, getFloatingProps } = (0, _reactdominteractions.useInteractions)([
        hover,
        focus,
        role,
        dismiss
    ]);
    const basicTooltipContent = (0, _react.useMemo)(()=>{
        return /*#__PURE__*/ _react.default.createElement(_Text.Text, {
            variant: "text",
            size: "extra-small",
            className: "title m-0"
        }, title);
    }, [
        title
    ]);
    const advancesTooltipContent = (0, _react.useMemo)(()=>{
        return /*#__PURE__*/ _react.default.createElement("div", {
            className: "jsx-59bdc91775867f4a" + " " + "advanced-container"
        }, imageUrl != null && imageUrl.length > 0 && /*#__PURE__*/ _react.default.createElement("img", {
            src: imageUrl,
            alt: title,
            onLoad: update,
            className: "jsx-59bdc91775867f4a"
        }), /*#__PURE__*/ _react.default.createElement("div", {
            className: "jsx-59bdc91775867f4a" + " " + "inner-content"
        }, /*#__PURE__*/ _react.default.createElement(_Text.Text, {
            variant: "text",
            size: "small",
            className: "title m-0"
        }, title), description != null && /*#__PURE__*/ _react.default.createElement(_Text.Text, {
            variant: "text",
            size: "extra-small",
            className: "m-0 ".concat(title != null || imageUrl != null ? "mt-2" : "")
        }, description), (primaryAction != null || secondaryAction != null) && /*#__PURE__*/ _react.default.createElement("div", {
            className: "jsx-59bdc91775867f4a" + " " + "actions"
        }, secondaryAction != null && secondaryAction, primaryAction != null && primaryAction)), /*#__PURE__*/ _react.default.createElement(_style.default, {
            id: "59bdc91775867f4a"
        }, ".advanced-container.jsx-59bdc91775867f4a{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:.5rem}.inner-content.jsx-59bdc91775867f4a{padding:.5rem}.inner-content.jsx-59bdc91775867f4a .title{font-weight:600!important}.actions.jsx-59bdc91775867f4a{margin-top:1rem;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-moz-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;gap:.5rem}img.jsx-59bdc91775867f4a{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;overflow:hidden;z-index:1}"));
    }, [
        title,
        description,
        primaryAction,
        secondaryAction,
        imageUrl
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, manualInteractionsControl ? children : /*#__PURE__*/ _react.default.cloneElement(children, {
        ref: reference,
        ...getReferenceProps()
    }), isActive && /*#__PURE__*/ _react.default.createElement("div", {
        ref: floating,
        ...getFloatingProps,
        className: _style.default.dynamic([
            [
                "3a60c075ed622e1f",
                [
                    strategy,
                    y !== null && y !== void 0 ? y : 0,
                    x !== null && x !== void 0 ? x : 0,
                    isMobile ? "initial" : "max-content",
                    actualPlacement,
                    limitWidth ? "50%" : "326px",
                    zIndexes.tooltips,
                    [
                        "top",
                        "bottom"
                    ].includes(actualPlacement) ? "center" : "left",
                    arrowX != null ? "".concat(arrowX, "px") : "",
                    arrowY != null ? "".concat(arrowY, "px") : "",
                    arrowSide,
                    [
                        "left",
                        "right"
                    ].includes(arrowSide) ? 6 : 4,
                    arrowRotateDegree,
                    arrowSide,
                    [
                        "left",
                        "right"
                    ].includes(arrowSide) ? 12 : 8
                ]
            ]
        ]) + " " + (getFloatingProps && getFloatingProps.className != null && getFloatingProps.className || "tooltip tooltip--".concat(variant))
    }, (showArrow || variant === "advanced") && /*#__PURE__*/ _react.default.createElement("div", {
        ref: arrowRef,
        className: _style.default.dynamic([
            [
                "3a60c075ed622e1f",
                [
                    strategy,
                    y !== null && y !== void 0 ? y : 0,
                    x !== null && x !== void 0 ? x : 0,
                    isMobile ? "initial" : "max-content",
                    actualPlacement,
                    limitWidth ? "50%" : "326px",
                    zIndexes.tooltips,
                    [
                        "top",
                        "bottom"
                    ].includes(actualPlacement) ? "center" : "left",
                    arrowX != null ? "".concat(arrowX, "px") : "",
                    arrowY != null ? "".concat(arrowY, "px") : "",
                    arrowSide,
                    [
                        "left",
                        "right"
                    ].includes(arrowSide) ? 6 : 4,
                    arrowRotateDegree,
                    arrowSide,
                    [
                        "left",
                        "right"
                    ].includes(arrowSide) ? 12 : 8
                ]
            ]
        ]) + " " + "arrow"
    }), variant === "advanced" ? advancesTooltipContent : basicTooltipContent), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "3a60c075ed622e1f",
        dynamic: [
            strategy,
            y !== null && y !== void 0 ? y : 0,
            x !== null && x !== void 0 ? x : 0,
            isMobile ? "initial" : "max-content",
            actualPlacement,
            limitWidth ? "50%" : "326px",
            zIndexes.tooltips,
            [
                "top",
                "bottom"
            ].includes(actualPlacement) ? "center" : "left",
            arrowX != null ? "".concat(arrowX, "px") : "",
            arrowY != null ? "".concat(arrowY, "px") : "",
            arrowSide,
            [
                "left",
                "right"
            ].includes(arrowSide) ? 6 : 4,
            arrowRotateDegree,
            arrowSide,
            [
                "left",
                "right"
            ].includes(arrowSide) ? 12 : 8
        ]
    }, ".tooltip.__jsx-style-dynamic-selector{position:".concat(strategy, ";top:").concat(y !== null && y !== void 0 ? y : 0, "px;left:").concat(x !== null && x !== void 0 ? x : 0, "px;width:").concat(isMobile ? "initial" : "max-content", ";margin-").concat(actualPlacement, ":.25rem;max-width:").concat(limitWidth ? "50%" : "326px", ";color:#fff;background:rgba(0,0,0,.8);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;padding:.25rem .5rem;z-index:").concat(zIndexes.tooltips, ";text-transform:none;opacity:1}.tooltip--basic.__jsx-style-dynamic-selector .title{margin:0;text-align:").concat([
        "top",
        "bottom"
    ].includes(actualPlacement) ? "center" : "left", "}.tooltip--advanced.__jsx-style-dynamic-selector{width:296px;padding:.5rem;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px}.arrow.__jsx-style-dynamic-selector{position:absolute;left:").concat(arrowX != null ? "".concat(arrowX, "px") : "", ";top:").concat(arrowY != null ? "".concat(arrowY, "px") : "", ";").concat(arrowSide, ":-").concat([
        "left",
        "right"
    ].includes(arrowSide) ? 6 : 4, "px;-webkit-transform:rotate(").concat(arrowRotateDegree, "deg);-moz-transform:rotate(").concat(arrowRotateDegree, "deg);-ms-transform:rotate(").concat(arrowRotateDegree, "deg);-o-transform:rotate(").concat(arrowRotateDegree, "deg);transform:rotate(").concat(arrowRotateDegree, "deg);border-color:transparent;border-top-color:rgba(0,0,0,.8);border-style:solid;border-width:.25rem .25rem 0;width:0;height:0;line-height:0}.tooltip--advanced.__jsx-style-dynamic-selector .arrow.__jsx-style-dynamic-selector{border-width:.5rem .5rem 0;").concat(arrowSide, ":-").concat([
        "left",
        "right"
    ].includes(arrowSide) ? 12 : 8, "px}")));
};

//# sourceMappingURL=Tooltip.js.map